import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fcd2ca3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "homeView" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "homeBg",
  style: {"width":"720px","height":"343px"}
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "欢迎使用养殖险验标系统！", -1))
const _hoisted_4 = { class: "img-url" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["href"]

import Cookies from "js-cookie";
import { getUserInfo } from "@/views/Login/api.js";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const Router = useRouter();

// 响应式数据
const downloadLink = ref(process.env.VUE_APP_DOWN);
const imageName = ref("../../assets/image/download.png");

// 初始化图片路径
imageName.value = require(process.env.VUE_APP_IMG || "../../assets/image/download.png");
console.log(process.env.VUE_APP_IMG, imageName.value);
// 生命周期钩子
onMounted(() => {
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        class: "img",
        src: imageName.value,
        alt: ""
      }, null, 8, _hoisted_5),
      _createElementVNode("a", { href: downloadLink.value }, _toDisplayString(downloadLink.value), 9, _hoisted_6)
    ])
  ]))
}
}

})